import accountNotifications from './accountNotifications';
import accountSpendLimit from './accountSpendLimit';
import utility from './utility'

const accountStatus = {
    init: function() {
        const editStatusDetailsButton = document.querySelector("#account--status-edit");
        if (editStatusDetailsButton) {
            editStatusDetailsButton.onclick = () => {
                this.showAccountStatusPopup();
            };
        }

        const showDeactivateAccount = document.getElementById("account--status-show-break");
        if (showDeactivateAccount) {
            showDeactivateAccount.onclick = () => {
                utility.showPopup(document.getElementById("account--status-deactivate-popup"));
            }
        }

        const showCloseAccount = document.getElementById("account--status-show-close");
        if (showCloseAccount) {
            showCloseAccount.onclick = () => {
                utility.showPopup(document.getElementById("account--status-close-popup"));
            }
        }

        const deactivateSubmit = document.getElementById("account--status-deactivate-submit");
        if (deactivateSubmit) {
            deactivateSubmit.onclick = () => {
                const deactivateType = document.querySelector("#account--status-deactivate-form input[name=TypeId]:checked");
                if (deactivateType) {
                    if (deactivateType.value == "DEMA") {
                        // too many emails popup
                        utility.showPopup(document.getElementById("account--status-deactivate-notifications-popup"));
                    }
                    else if (deactivateType.value == "DSPD") {
                        // reduce spending
                        utility.showPopup(document.getElementById("account--status-deactivate-spending-popup"));
                    }
                    else {
                        // submit
                        this.requestDeactivateAccount();
                    }
                }
            };
        }

        const closeSubmit = document.getElementById("account--status-close-submit");
        if (closeSubmit) {
            closeSubmit.onclick = () => {
                const closeType = document.querySelector("#account--status-close-form input[name=TypeId]:checked");
                if (closeType) {
                    if (closeType.value == "CEMA") {
                        // too many emails
                        utility.showPopup(document.getElementById("account--status-close-notifications-popup"));
                    }
                    else if (closeType.value == "CSPD") {
                        // reduce spending
                        utility.showPopup(document.getElementById("account--status-close-spending-popup"));
                    }
                    else if (closeType.value == "CILT") {
                        // take a break
                        utility.showPopup(document.getElementById("account--status-close-deactivate-popup"));
                    }
                    else {
                        this.requestCloseAccount();
                    }
                }
            }
        }

        const editStatusDeactivateNotificationContinue = document.getElementById("account--status-deactivate-notifications-continue");
        if (editStatusDeactivateNotificationContinue) {
            editStatusDeactivateNotificationContinue.onclick = () => {
                this.requestDeactivateAccount();
            };
        }

        const editStatusDeactivateNotificationChange = document.getElementById("account--status-deactivate-notifications-change");
        if (editStatusDeactivateNotificationChange) {
            editStatusDeactivateNotificationChange.onclick = () => {
                accountNotifications.showEmailNotificationsPopup();
            };
        }

        const editStatusCloseNotificationContinue = document.getElementById("account--status-close-notifications-continue");
        if (editStatusCloseNotificationContinue) {
            editStatusCloseNotificationContinue.onclick = () => {
                this.requestCloseAccount();
            };
        }

        const editStatusCloseNotificationChange = document.getElementById("account--status-close-notifications-change");
        if (editStatusCloseNotificationChange) {
            editStatusCloseNotificationChange.onclick = () => {
                accountNotifications.showEmailNotificationsPopup();
            };
        }

        const editStatusDeactivateSpendingContinue = document.getElementById("account--status-deactivate-spending-continue");
        if (editStatusDeactivateSpendingContinue) {
            editStatusDeactivateSpendingContinue.onclick = () => {
                this.requestDeactivateAccount();
            };
        }

        const editStatusDeactivateSpendingChange = document.getElementById("account--status-deactivate-spending-change");
        if (editStatusDeactivateSpendingChange) {
            editStatusDeactivateSpendingChange.onclick = () => {
                accountSpendLimit.showAccountSpendLimitPopup();
            };
        }

        const editStatusCloseSpendingContinue = document.getElementById("account--status-close-spending-continue");
        if (editStatusCloseSpendingContinue) {
            editStatusCloseSpendingContinue.onclick = () => {
                this.requestCloseAccount();
            };
        }

        const editStatusCloseSpendingChange = document.getElementById("account--status-close-spending-change");
        if (editStatusCloseSpendingChange) {
            editStatusCloseSpendingChange.onclick = () => {
                accountSpendLimit.showAccountSpendLimitPopup();
            };
        }

        const editStatusDeactivateContinue = document.getElementById("account--status-deactivate-continue");
        if (editStatusDeactivateContinue) {
            editStatusDeactivateContinue.onclick = () => {
                this.requestCloseAccount();
            };
        }

        const editStatusDeactivateChange = document.getElementById("account--status-deactivate-change");
        if (editStatusDeactivateChange) {
            editStatusDeactivateChange.onclick = () => {
                utility.showPopup(document.querySelector("#account--status-deactivate-popup"));
            };
        }
    },

    showAccountStatusPopup: function() {
        utility.showPopup(document.querySelector("#account--status-popup"));
    },

    requestDeactivateAccount: function() {
        const ajaxOptions = {
            url: "/api/web/account/deactivate-account",
            method: "POST",
            data: utility.getFormData(document.querySelector("#account--status-deactivate-form")),
            success: function(e) {
                const result = JSON.parse(e.target.responseText);
                if (result.success) {
                    var message = result.messages[0];
                    if (result.messages.length > 1) {
                        for (var i = 1; i < result.messages.length; i++) {
                            message = message + "<br/><br/>" + result.messages[i];
                        }
                    }
                    utility.showNotificationPopup({
                        title: "Success!",
                        content: message,
                        hideCloseIcon: true,
                        button: {
                            text: "OK",
                            url: "/account/"
                        }
                    });
                }
                else {
                    utility.showNotificationPopup({
                        title: "Error",
                        content: result.messages[0]
                    });
                }
            },
            always: function() {
                utility.enableButton(document.querySelector("#account--status-deactivate-form button[type=button]"));
                utility.enableButton(document.getElementById("account--status-deactivate-notifications-continue"));
                utility.enableButton(document.getElementById("account--status-deactivate-spending-continue"));
            }
        };
        utility.disableButton(document.querySelector("#account--status-deactivate-form button[type=button]"));
        utility.disableButton(document.getElementById("account--status-deactivate-notifications-continue"));
        utility.disableButton(document.getElementById("account--status-deactivate-spending-continue"));
        utility.ajaxRequest(ajaxOptions);
    },

    requestCloseAccount: function() {
        const ajaxOptions = {
            url: "/api/web/account/close-account",
            method: "POST",
            data: utility.getFormData(document.querySelector("#account--status-close-form")),
            success: function(e) {
                const result = JSON.parse(e.target.responseText);
                if (result.success) {
                    var returnUrl = window.location.href;
                    if (result.returnUrl && result.returnUrl != null) {
                        returnUrl = result.returnUrl;
                    }
                    var centreContent = result.messages.length == 1;
                    var message = result.messages[0];
                    if (result.messages.length > 1) {
                        for (var i = 1; i < result.messages.length; i++) {
                            message = message + "<br/><br/>" + result.messages[i];
                        }
                    }
                    utility.showNotificationPopup({
                        title: "We're sorry to see you go.",
                        content: message,
                        centreContent: centreContent,
                        hideCloseIcon: true,
                        button: {
                            text: "OK",
                            url: returnUrl
                        }
                    });
                }
                else {
                    utility.showNotificationPopup({
                        title: "Error",
                        content: result.messages[0]
                    });
                }
            },
            always: function() {
                utility.enableButton(document.querySelector("#account--status-close-form button[type=button]"));
                utility.enableButton(document.getElementById("account--status-close-notifications-continue"));
                utility.enableButton(document.getElementById("account--status-close-spending-continue"));
            }
        };
        utility.disableButton(document.querySelector("#account--status-close-form button[type=button]"));
        utility.disableButton(document.getElementById("account--status-close-notifications-continue"));
        utility.disableButton(document.getElementById("account--status-close-spending-continue"));
        utility.ajaxRequest(ajaxOptions);
    }
}

export default accountStatus


// WEBPACK FOOTER //
// ./assets/src/js/classes/accountStatus.js